import { Link } from 'react-router-dom';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-cloudy-line' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-customer-service-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-contrast-drop-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-vip-crown-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-bear-smile-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-links-line' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">Explore Product <span className="italic font-normal text-accent-500">Categories</span></h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">Browse through our curated product categories and discover the best spreadsheet resources for smarter shopping decisions.</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-100 rounded-lg p-4 md:p-5 flex flex-col items-center justify-center text-center transition-all duration-300 hover:bg-accent-100/60 cursor-pointer min-h-[100px]"
            >
              {idx === 0 && (
                <span className="absolute top-2 left-2 bg-accent-500 text-white text-[10px] font-semibold px-2 py-0.5 rounded-full">Hot</span>
              )}
              <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center text-accent-500 group-hover:text-accent-600 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </span>
              <span className="mt-2 text-xs md:text-sm font-medium text-foreground-800 group-hover:text-foreground-950 whitespace-nowrap">{cat.name}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}